<fa-icon
  *ngIf="status"
  [icon]="circle"
  [size]="'xs'"
  class="EmailStatus-{{ status }}"></fa-icon>
